import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery } from '@mui/material';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { assets } from '../../../assets/assets';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMultipleQuotationData } from '../../../Store/PHPSlice/Sale/MultipleQuot';
import { selectMultipleQuotData } from '../../Selectors/Master/MasterSelectors';
import { useParams } from 'react-router-dom';
import FirmHeaderImg from '../../FieldsComponents/FirmHeaderImg';

const MultiQuotView = () => {
    const { Id } = useParams();
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef();
    const dispatch = useDispatch();
    const mqtdata = useSelector(selectMultipleQuotData);

    useEffect(() => {
        dispatch(fetchMultipleQuotationData(Id));
    }, [Id]);

    console.log(mqtdata);
    const formdata = mqtdata?.data;
    const tableContainerStyle = {
        marginLeft: isDesktop ? '0%' : '0%',
        width: isDesktop ? '98%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };


    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1%', width: '100%' }} ref={componentRef}>

                        {/* <img src={assets?.firmImg} alt="error" /> */}

                        {mqtdata?.data?.firmId !== '' && <FirmHeaderImg firmId={mqtdata?.data?.firmId} />}

                        <h3 className='centered-heading'>Quotation</h3>
                        <div className="dashed-line" style={{ margin: '1% 0%' }}></div>

                        <table style={{ margin: '1% 0%', fontSize: '15px' }}>

                            <tbody>

                                <tr>

                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Date</td>

                                    <td style={{ padding: ' 0.2% 1%', width: '150px' }} className='dark-color'>{formdata?.dt}</td>
                                    <td style={{ width: '200px' }}>Multiple Quot. Memo</td>

                                    <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formdata?.qtMemo}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Firm</td>

                                    <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formdata?.firmNm}</td>
                                    <td style={{ width: '200px' }}>Party</td>

                                    <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formdata?.partyNm}</td>

                                </tr>

                            </tbody>

                        </table>

                        <h3 className='centered-heading'>Price List</h3>

                        {formdata?.data2?.length > 0 &&

                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                {
                                    formdata?.data2?.map((quot, index) => (
                                        <Table key={index}>
                                            <TableHead>
                                                <TableRow className='tbl-row'>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '5%' }} align='center'>Quotation No</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '30%' }} align='center'>Size</TableCell>
                                                    {quot?.Info ? quot?.Info?.map((item, index) => (
                                                        <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item?.size}</TableCell>
                                                    )) : ''}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{quot?.quotNo}</TableCell>

                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{quot?.itemNm} -
                                                        <br /> {quot?.mclothNm} {quot?.m1cloth !== '0' && <br />}{quot?.m1cloth !== '0' && quot?.m1clothNm} {quot?.m2cloth !== '0' && <br />}
                                                        {quot?.m2cloth !== '0' && quot?.m2clothNm} {quot?.m3cloth !== '0' && <br />}{quot?.m3cloth !== '0' && quot?.m3clothNm}</TableCell>
                                                    {quot?.Info ? quot?.Info?.map((item, index) => (
                                                        <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item?.rate}</TableCell>
                                                    )) : ''}
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    ))
                                }
                            </TableContainer>
                        }
                          <div style={{ marginTop: '3%', marginLeft: '5%' }}>
        <h4 style={{ marginBottom: '8px', textDecoration: 'underline' }}>Terms & Conditions</h4>
        <ol style={{ fontSize: '15px', lineHeight: '1.6' }}>
            <li>50% adv on order and remaining at the time of delivery.</li>
            <li>Fancy Shirting & Suiting order as per lump.</li>
            <li>GST will be charged extra.</li>
            <li>Above Rates are applicable only for Basic Pattern , any additional job will be charged extra as below.</li>
            <li>Logo , Embordery or printing will be charge extra.</li>
            <li>Special order will be supplied after 40 to 60 days of final order.</li>
            <li>Price list may be changed without any previous notice.</li>
        </ol>
    </div>
                        <div style={{ float: 'right', marginRight: '10%', textAlign: 'center' }}>
                            <h4 style={{ marginBottom: '3rem' }}>Authorized By</h4>
                            <h6>{formdata?.firmNm}</h6>
                        </div>
                    </div>
                    <div style={{ margin: '2% 5%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
}

export default MultiQuotView;
